import React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import { Box, Typography } from '@mui/material';

const DownloadReportButton = ({ onClick }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        border: '2px dashed #ccc',
        borderRadius: '8px',
        width: '200px',
        height: '120px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: '#f5f5f5',
        },
      }}
    >
      <DownloadIcon sx={{ fontSize: 30, mb: 1 }} />
      <Typography variant="body1" fontWeight="500">
        Download report
      </Typography>
    </Box>
  );
};

export default DownloadReportButton;
